import * as React from "react";
import Loading, { LoadingTheme } from "../../loading/Loading";

import * as styles from "./Picture.less";

type Props = {
    alt: string;
    src: string;
    setInnerRef: (el: HTMLImageElement) => void;
    loading?: boolean;
    onLoaded?: () => void;
};

export const Picture: React.FC<Props> = ({ alt, src, setInnerRef, loading, onLoaded }) => {
    const imgRef = React.useRef<HTMLImageElement>();

    React.useEffect(() => {
        setInnerRef(imgRef.current);
    }, []);

    return (
        <>
            {loading && (
                <div className={styles.loading}>
                    <Loading theme={LoadingTheme.big} />
                </div>
            )}
            <img alt={alt} src={src} draggable={false} ref={imgRef} onError={onLoaded} onLoad={onLoaded} />
        </>
    );
};
